
    import './styles.scoped.css';
    export default {
  "block-body-scroll": "awsui_block-body-scroll_19d8l_1xapg_97",
  "mobile-bar": "awsui_mobile-bar_19d8l_1xapg_101",
  "mobile-bar-breadcrumbs": "awsui_mobile-bar-breadcrumbs_19d8l_1xapg_115",
  "mobile-trigger-with-drawers": "awsui_mobile-trigger-with-drawers_19d8l_1xapg_122",
  "mobile-toggle": "awsui_mobile-toggle_19d8l_1xapg_128",
  "mobile-toggle-with-drawers": "awsui_mobile-toggle-with-drawers_19d8l_1xapg_138"
};
  